import {environment} from '../../environments/environment';

export class EditorConfigHelper {

  public static get editorApiKey() {
    return environment.editor.tinyApiKey;
  }

  public static config(locale: string, placeholderText: string = '',
                       enableElementPath: boolean = true, height: number = 320, compact = false): object {
    const toolbar = compact
      ? 'undo redo | bold italic | alignleft aligncenter alignright alignjustify lineheight | link | bullist numlist | forecolor | help'
      : 'undo redo | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify lineheight | link | bullist numlist outdent indent | forecolor backcolor removeformat | help';


    return {
      height: height,
      language: locale,
      menubar: false,
      elementpath: enableElementPath,
      placeholder: placeholderText,
      fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
      content_style: 'body {font-size: 10pt;}',
      mobile: {
        menubar: true,
        plugins: [
          'lists',
          'link',
          'autolink'
        ]
      },
      plugins: [
        'link',
        'autolink',
        'lists',
        'help',
        'wordcount'
      ],
      toolbar: toolbar,
      help_tabs: [
        'shortcuts'
      ],
      automatic_uploads: false,
      block_unsupported_drop: true,
      paste_block_drop: false,
      paste_data_images: false,
      images_file_types: '', // block all image formats from upload & paste
      default_link_target: '_blank',
      link_default_protocol: 'https',
      target_list: false,
      browser_spellcheck: true,
    };
  }

}
